/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UserEvaluationSurveyAnswerDto
 */
export interface UserEvaluationSurveyAnswerDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof UserEvaluationSurveyAnswerDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserEvaluationSurveyAnswerDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof UserEvaluationSurveyAnswerDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof UserEvaluationSurveyAnswerDto
     */
    deleted: string | null;

    /**
     * Free-form value for PLAIN_* question types; null for choice-based questions
     *
     * @type {string}
     * @memberof UserEvaluationSurveyAnswerDto
     */
    value: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UserEvaluationSurveyAnswerDto
     */
    survey: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof UserEvaluationSurveyAnswerDto
     */
    question: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof UserEvaluationSurveyAnswerDto
     */
    answer: JoinEntityDto | null;
}
